import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Input from '../../form/Input'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'

const TestEmailModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.testEmailModalVisible}
        onClose={distributeStore.hideTestEmailModal}
    >
        <Typography type="h2">
            {i18n.t('distributionTestEmailModal.title')}
        </Typography>

        <Typography>
            {i18n.t('distributionTestEmailModal.subtitle')}
        </Typography>

        <br />

        <Input
            label={i18n.t('gen_email_address')}
            placeholder={i18n.t('form.input.placeholder')}
            onBlur={distributeStore.changeTestEmailAddress}
        />

        {distributeStore.invalidTestEmail
            ? (
                <div className="test-email-warning">
                    <i className="fal fa-circle-info" />

                    <p>{i18n.t('distributionTestEmailModal.warning')}</p>
                </div>
            ) : null}

        <br />

        <hr />

        <br />

        <div className="delete-modal-footer-content">
            <Button
                cssClass="regular tertiary"
                onClick={distributeStore.hideTestEmailModal}
            >
                {i18n.t('back')}
            </Button>

            <Button
                cssClass="regular primary"
                onClick={distributeStore.sendTestEmail}
                disabled={
                    !distributeStore.testEmailAddress.length
                    || distributeStore.invalidTestEmail
                }
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <i className="fal fa-envelope" />

                    {i18n.t('s_test_schedule_email')}
                </div>
            </Button>
        </div>
    </Modal>
)

export default observer(TestEmailModal)
